/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Col_ParcelInputs */

const vi_care_log_col_parcel = /** @type {(inputs: Care_Log_Col_ParcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên bãi`)
};

/**

* @param {Care_Log_Col_ParcelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_col_parcel = /** @type {((inputs?: Care_Log_Col_ParcelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Col_ParcelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_col_parcel(inputs)
});